<template>
  <el-container class="screen" direction="vertical">
    <page-banner
      :heading="favoritesData ? favoritesData.favoritesHeader : ''"
      :subHeading="favoritesData ? favoritesData.favoritesSubhead : ''"
      :centerHeader="true"
    />
    <home-favorites
      :fullPage="true"
      class="favorites"
    >

    </home-favorites>
    <footer-main/>
  </el-container>
</template>

<script>
  import FooterMain from '@/components/footer/FooterMain.vue';
  import HomeFavorites from '@/components/home/HomeFavorites.vue';
  import PageBanner from '@/components/PageBanner.vue';
  import { mapState } from 'vuex';
  import favorites from '@/components/favorites'

  export default {
    name: 'Favorites',
    computed: {
      ...mapState(favorites.store.namespace, [
        'favoritesData'
      ])
    },
    components: {
      FooterMain,
      HomeFavorites,
      PageBanner,
    },
  }

  //////////


</script>

<style lang="scss" scoped>
  @import 'element-theme-chalk/src/mixins/mixins.scss';

  .page {
    &--container {
      margin: 0 !important;
    }
  }

  .page__banner {
    margin-bottom: 0px;
    padding: 150px 0;
  }

  .favorites {
    /* full height minus height of nav + hero */
    min-height: calc(100vh - 519px);
    margin: 50px 0;
  }

</style>
